import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface SEOProps {
  title?: string;
  description?: string;
}

const SEO = ({ title, description }: SEOProps = {}) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = "https://oraculus-x.com";
  
  const pageTitle = title || t('seo.title');
  const pageDescription = description || t('seo.description');

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={currentLang} />
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={t('seo.keywords')} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:locale" content={currentLang === 'en' ? 'en_US' : currentLang === 'de' ? 'de_DE' : 'es_ES'} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      
      {/* Hreflang Tags for multilingual SEO */}
      <link rel="alternate" hrefLang="en" href={`${baseUrl}/`} />
      <link rel="alternate" hrefLang="de" href={`${baseUrl}/?lang=de`} />
      <link rel="alternate" hrefLang="es" href={`${baseUrl}/?lang=es`} />
      <link rel="alternate" hrefLang="fr" href={`${baseUrl}/?lang=fr`} />
      <link rel="alternate" hrefLang="zh" href={`${baseUrl}/?lang=zh`} />
      <link rel="alternate" hrefLang="x-default" href={`${baseUrl}/`} />
    </Helmet>
  );
};

export default SEO;
